import { render, staticRenderFns } from "./CoreBMSMatchList.html?vue&type=template&id=0f70724e&external"
import script from "./CoreBMSMatchList.vue?vue&type=script&lang=js"
export * from "./CoreBMSMatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports